import axios from "axios";
import { signOut } from "aws-amplify/auth";
import { getIDToken, isIdTokenExpired, refreshIdToken } from "../services";

export default function JwtInterceptor() {
  axios.interceptors.request.use(
    async (req) => {
      let idToken = await getIDToken();
      if (idToken) {
        // const isTokenExpired = isIdTokenExpired();
        // if (isTokenExpired) {
        //   try {
        //     const {
        //       tokens: { idToken: newToken },
        //     } = await refreshIdToken();
        //     idToken = newToken;
        //   } catch (err) {
        //     signOut();
        //     console.log("ERROR", err);
        //   }
        // }
        req.headers.Authorization = "Bearer " + idToken;
        req.headers["X-Customer-Id"] = localStorage.getItem("simulatorCustomer") || 'visteon';
        return req;
      }
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}
